import { initChameleon, identifyChameleon } from '@chilipiper/tracking'
import { useEffect } from 'react'
import { environment } from '@chilipiper/config'
import { useFireSessionContext } from '@chilipiper/fire-session'
import { useDefaultMeetingType } from '@chilipiper/scheduling-shared'
import { useTenantDetails } from '../api/tenant'

initChameleon()

export const useAdoption = () => {
  const session = useFireSessionContext()
  const { data: tenantData } = useTenantDetails()
  const { data: defaultMeetingType } = useDefaultMeetingType(session.userId)
  useEffect(() => {
    const { userId, user, tenantId } = session
    if (user && environment.node !== 'test') {
      identifyChameleon(userId, {
        productLine: 'fire',
        email: user.email,
        name: user.name,
        tenantId,
        uid: tenantId,
        subdomain: tenantData?.tenantInfo.tenantData.subdomain,
      })
    }
  }, [session, tenantData, defaultMeetingType])
}
